import { Button, Dialog, DialogTitle } from '@mui/material';
import { Stack } from '@mui/system';
import useClinicDocument from 'hooks/useClinicDocument';
import useClinicDocuments from 'hooks/useClinicDocuments';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';
import { getErrorMessage } from 'utils/stringUtils';

const DeleteDocumentModal = ({ onClose, documentId, noteId, docId, openModal }: any) => {
  const { enqueueSnackbar } = useSnackbar();

  const { deleteDoc, isDeletingDoc, deleteDocument, isDeletingDocument } = useClinicDocument({
    documentId,
    noteId,
    docId
  });
  const { refetchDocuments } = useClinicDocuments();

  const handleDelete = async () => {
    try {
      let data;

      if (docId) {
        data = await deleteDoc();
      } else {
        data = await deleteDocument();
        refetchDocuments();
      }

      enqueueSnackbar(data.message, { variant: 'success' });

      onClose();
    } catch (e) {
      enqueueSnackbar(getErrorMessage(e), { variant: 'error' });
    }
  };

  return (
    <>
      <Dialog open={openModal} onClose={onClose}>
        <DialogTitle>
          {docId && <FormattedMessage defaultMessage="Are you sure you want to delete this document?" />}
          {noteId && <FormattedMessage defaultMessage="Are you sure you want to delete this note?" />}
          {!docId && !noteId && <FormattedMessage defaultMessage="Are you sure you want to delete this folder?" />}
        </DialogTitle>
        <Stack direction={'row'} spacing={2} m={2} justifyContent="flex-end">
          <Button variant="contained" onClick={handleDelete} disabled={!!docId ? isDeletingDoc : isDeletingDocument}>
            <FormattedMessage defaultMessage={'Delete'} />
          </Button>
          <Button variant="outlined" onClick={onClose}>
            <FormattedMessage defaultMessage={'Cancel'} />
          </Button>
        </Stack>
      </Dialog>
    </>
  );
};

export default DeleteDocumentModal;
